import { Box } from '@mui/material';
import { PlayByPlayPanel } from '../../ses/components/PlayByPlayPanel';
import useCurrentGameId from '@/shared/hooks/useCurrentGameId';
import { ClipEventMetadata } from '../../ses/components/ClipCreationContent';
import { SportEvent } from '../../ses/types/SportEventTypes';

interface PlayByPlayTabProps {
  width?: number;
  onCreateClip?: (event: SportEvent, metadata: ClipEventMetadata) => void;
}

export const PlayByPlayTab = ({ width, onCreateClip }: PlayByPlayTabProps) => {
  const gameId = useCurrentGameId();

  if (!gameId) {
    return (
      <Box
        sx={{
          p: 2,
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        No game selected
      </Box>
    );
  }

  return <PlayByPlayPanel width={width} onCreateClip={onCreateClip} />;
};
export default PlayByPlayTab;
